<template>
  <div class="app-title">{{$t(`ROUTE_NAME.${title}`)}}
    <Fab v-if="fabExists" :fabList="fabList" :routeName="title"/>
  </div>
</template>

<script>
import Fab from './Fab.vue'

export default {
  props: {
    title: String,
    fabList: Object
  },
  computed: {
    fabExists () {
      return this.fabList[this.title] !== undefined
    }
  },
  components: {
    Fab
  }
}
</script>


// WEBPACK FOOTER //
// src/components/PageTitle.vue